import { ServerConfig } from "@/config/config";
import { LogEntry } from "@/models/log";
import { Axios } from "@/services/auth-service";
import { IBrowseResponse } from "@/utils/browse/browse-request";
import { HumanFilter } from "@/utils/browse/human-filter";

export class LogServiceClass{
	private readonly url = `${ServerConfig.host}/logs/admin`;

	async getLogEntries(filters:HumanFilter[], order:string, orderDirection:string, page:number, limit:number):Promise<IBrowseResponse<LogEntry>> {
		let result = await Axios.get(this.url, {
			params: {
				filters: JSON.stringify(filters),
				order,
				orderDirection,
				offset: limit * (page-1),
				limit
			}
		});

		return {
			items: result.data.data.map((l:any) => new LogEntry(l)),
			count: result.data.records
		};
	}

	async getApps():Promise<string[]> {
		let result = await Axios.get(`${this.url}/apps`);
		return result.data;
	}

	async deleteLogEntries(logs:LogEntry[]):Promise<void> {
		await Axios.delete(this.url, {
			data: logs.map(l => l.id)
		});
	}

	// Deletes logs and returns amount of rows deleted
	async deleteLogsByAppName(appName:string):Promise<number>{
		let result = await Axios.delete(`${this.url}/${appName}`);
		return result.data.rowsDeleted;
	}

	async deleteLogsByAppNameOlderThenDate(appName:string, date:Date):Promise<number>{
		let result = await Axios.delete(`${this.url}/${appName}/older-then-date/${encodeURIComponent(date.toJSON())}`);
		return result.data.rowsDeleted;
	}
};

export const LogService = new LogServiceClass();